import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "top0" }
const _hoisted_2 = {
  key: 0,
  class: "left transport tabsUp"
}
const _hoisted_3 = { class: "breadcrumbs" }
const _hoisted_4 = { class: "stationNumber" }
const _hoisted_5 = { class: "stationName" }
const _hoisted_6 = { class: "pathLine" }
const _hoisted_7 = { class: "mainStation" }
const _hoisted_8 = { class: "stationName" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "primaryLine" }, null, -1)
const _hoisted_10 = { class: "stationNumber" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "dot" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "verticalLine" })
], -1)
const _hoisted_12 = { class: "location" }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "dot" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "verticalLine" })
], -1)
const _hoisted_15 = { class: "location" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = { class: "lastStation" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "dot" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dotTwo" })
], -1)
const _hoisted_19 = { class: "location" }
const _hoisted_20 = { class: "title" }
const _hoisted_21 = {
  key: 0,
  class: "map"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MapCustom = _resolveComponent("MapCustom")!
  const _component_SidebarWrapper = _resolveComponent("SidebarWrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SidebarWrapper, {
      sidebarComponent: _ctx.sidebarComponent,
      sidebarLeft: true
    }, {
      default: _withCtx(() => [
        (_ctx.trip)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.trip.route.short_name || _ctx.trip.headsign), 1),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.trip.route.long_name || _ctx.trip.headsign), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.trip.route.short_name || _ctx.trip.headsign), 1)
                  ]),
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.firstStop.stop.name), 1)
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.middleStops, (stop) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "midStation",
                    key: stop.id
                  }, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(stop.stop.name), 1)
                    ])
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.lastStop.stop.name), 1)
                  ])
                ])
              ]),
              (_ctx.markers !== null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createVNode(_component_MapCustom, {
                      center: _ctx.markers[0].position,
                      markers: _ctx.markers
                    }, null, 8, ["center", "markers"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["sidebarComponent"])
  ]))
}